import React from 'react';

const PAGINATION_SKELETON_CARDS = ['wide', 'medium', 'short'];

const ActivityPaginationLoading = () => (
  <div
    className="activity-end-loading"
    role="status"
    aria-label="Loading more activities"
    aria-busy="true"
  >
    {PAGINATION_SKELETON_CARDS.map(variant => (
      <div
        key={variant}
        className={`activity-pagination-skeleton activity-pagination-skeleton-${variant}`}
        aria-hidden="true"
      >
        <span className="activity-skeleton activity-pagination-dot" />
        <span className="activity-skeleton activity-pagination-line" />
        <span className="activity-skeleton activity-pagination-meta" />
      </div>
    ))}
  </div>
);

export default ActivityPaginationLoading;
